var _defs, _path, _circle, _path2, _circle2, _path3, _circle3, _path4, _circle4, _path5, _circle5, _path6, _path7, _path8, _path9, _path10, _path11;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGanttcolors(_ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 420 585",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("mask", {
    id: "mask",
    width: 420,
    height: 585,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "mask0",
    width: 420,
    height: 585,
    fill: "#fff",
    rx: 20
  })))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#df4b85",
    d: "M337 355h34a8 8 0 018 8 8 8 0 01-8 8h-34z",
    opacity: 0.2,
    style: {
      isolation: "isolate"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#df4b85",
    d: "M138 363a8 8 0 018-8h48.49v16H146a8 8 0 01-8-8z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#df4b85",
    opacity: 0.5,
    style: {
      isolation: "isolate"
    },
    d: "M194.49 355h142.53v16H194.49z"
  }), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 106,
    cy: 363,
    r: 5,
    fill: "#2c2664"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#df4b85",
    d: "M312 302h59a8 8 0 018 8 8 8 0 01-8 8h-59z",
    opacity: 0.2,
    style: {
      isolation: "isolate"
    }
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#df4b85",
    d: "M138 310a8 8 0 018-8h96v16h-96a8 8 0 01-8-8z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#df4b85",
    opacity: 0.5,
    style: {
      isolation: "isolate"
    },
    d: "M242 302h70v16h-70z"
  }), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 106,
    cy: 310,
    r: 5,
    fill: "#2c2664"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#df4b85",
    d: "M290.51 408H371a8 8 0 018 8 8 8 0 01-8 8h-80.49z",
    opacity: 0.2,
    style: {
      isolation: "isolate"
    }
  }), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#df4b85",
    d: "M138 416a8 8 0 018-8h86.14v16H146a8 8 0 01-8-8z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#df4b85",
    opacity: 0.5,
    style: {
      isolation: "isolate"
    },
    d: "M194.48 408h96.02v16h-96.02z"
  }), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 106,
    cy: 416,
    r: 5,
    fill: "#2c2664"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#df4b85",
    d: "M336.64 461H371a8 8 0 018 8 8 8 0 01-8 8h-34.36z",
    opacity: 0.2,
    style: {
      isolation: "isolate"
    }
  }), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#df4b85",
    d: "M138 469a8 8 0 018-8h137v16H146a8 8 0 01-8-8z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#df4b85",
    opacity: 0.5,
    style: {
      isolation: "isolate"
    },
    d: "M194.48 461h142.15v16H194.48z"
  }), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 106,
    cy: 469,
    r: 5,
    fill: "#2c2664"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#df4b85",
    d: "M249.09 514H371a8 8 0 018 8 8 8 0 01-8 8H249.09z",
    opacity: 0.2,
    style: {
      isolation: "isolate"
    }
  }), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#df4b85",
    d: "M138 522a8 8 0 018-8h48.49v16H146a8 8 0 01-8-8z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#df4b85",
    opacity: 0.5,
    style: {
      isolation: "isolate"
    },
    d: "M194.48 514h54.6v16h-54.6z"
  }), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 106,
    cy: 522,
    r: 5,
    fill: "#2c2664"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#dadada",
    strokeWidth: 0.5,
    d: "M68 284h352"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#dadada",
    strokeWidth: 0.5,
    d: "M68 548h352"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#dadada",
    strokeWidth: 0.5,
    d: "M68 389.6h352"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#dadada",
    strokeWidth: 0.5,
    d: "M68 336.8h352"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#dadada",
    strokeWidth: 0.5,
    d: "M68 442.4h352"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#dadada",
    strokeWidth: 0.5,
    d: "M68 495.2h352"
  }))));
}

export default "data:image/svg+xml;base64,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";
export { SvgGanttcolors as ReactComponent };